let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b4T4f")).then(() => parcelRequire('5soOF'));